export default __webpack_public_path__ + "static/contact-d1b97a68b17ea91e07325049b86398cd.svg";